import React, { useState } from 'react';
import styled from 'astroturf/react';
import $ from 'jquery';

import { openFacebookShareDialog } from 'js/facebook/share_dialog';
import routes from 'js/core_pre_webpack/routes';
import AddIcon from 'js/design_system/icons/add.svg';
import CopyIcon from 'js/design_system/icons/content_copy.svg';
import { Icon } from 'js/design_system/Icon';
import ShareWorkModal from 'js/liswp/ShareWorkModal';
import { Work } from 'js/liswp/types';

import FacebookIcon from './FacebookIcon';
import BlueskyIcon from './BlueskyIcon';
import CitationModal from '../CitationModal';

const showToast = (message: string, options = {}) => {
  // NATIONAL PARKS: Replace with useToast hook if you're making any changes here.
  Components.Utils.showToast(
    // @ts-expect-error Components.Toasts.BasicToast is not typed
    Components.Toasts.BasicToast,
    { text: message },
    {
      timeMs: 3000,
      color: '', // Override with .Toast--content in article-page_dsv3.scss
      ...options,
    },
  );
};

const Container = styled.div`
  @import 'stylesheets/design_system/_deprecated_grid.scss';

  display: flex;
  align-items: center;
  height: 100%;
  gap: 8px;
`;

const Button = styled.button`
  @import 'stylesheets/journals/variables.scss';

  display: flex;
  flex-direction: column;
  align-items: center;
  width: 54px;

  background-color: transparent;
  color: $journal-blue1;
  border: none;

  &:hover {
    color: #5267a1;
  }
`;

const Label = styled.div`
  font-size: 12px;
  line-height: 14px;
  margin-top: 6px;
`;

const FontAwesomeIcon = styled('i')`
  font-size: 24px;
`;

type Props = {
  journalName: string;
  work: Work;
  citations?: { name: string; citation: string }[];
  published_letter_id: number;
};

export default function ArticleToolbar(props: Props) {
  const { journalName, work, citations, published_letter_id } = props;

  const [openModal, setOpenModal] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(work.internalUrl);

      showToast('URL copied to clipboard');
    } catch (_) {
      showToast('Something went wrong!', { color: 'Red' });
    }
  };

  const handleFacebook = () => {
    openFacebookShareDialog(work.internalUrl);
  };

  const handleTweet = () => {
    const tweetText = `[PDF] "${work.title}", published by ${journalName}`;
    const tweetVia = 'academia';

    // @ts-ignore legacy component
    window.Academia.openTwitterShareWindow(
      tweetText,
      work.internalUrl,
      tweetVia,
    );
  };

  const handleBluesky = () => {
    const blueskyText = `[PDF] "${work.title}", published by ${journalName} ${work.internalUrl}`;
    const blueskyUrl = `https://bsky.app/intent/compose?text=${encodeURIComponent(
      blueskyText,
    )}`;

    window.open(blueskyUrl, '_blank', 'noopener,noreferrer');
  };

  const handleShare = () => {
    // @ts-ignore legacy component
    Components.Utils.showModal(ShareWorkModal, {
      workId: work.id,
      workTitle: work.title,
      workUrl: work.internalUrl,
      collectionName: 'journals_work_card',
      source: 'journals_article_share',
      hideModal: () => $('.modal').modal('hide'),
    });
  };

  const handleSave = async () => {
    await $.ajax({
      type: 'POST',
      url: routes.api_v0_bookmarks_path({
        'bookmark[content_id]': work.id,
        'bookmark[source]': 'work_strip',
        'bookmark[content_type]': 'Work',
        subdomain_param: 'api',
      }),
    });

    showToast('Article bookmarked');
  };

  const openCitationsModal = () => {
    setOpenModal(true);
  };

  const closeCitationsModal = () => {
    setOpenModal(false);
  };

  return (
    <Container className="sap__share-work-toolbar">
      {citations && (
        <>
          <Button onClick={openCitationsModal}>
            <Icon name="format_quote" />
            <Label>Cite</Label>
          </Button>
          <CitationModal
            open={openModal}
            citations={citations}
            onClose={closeCitationsModal}
            entity_id={published_letter_id}
            source="letters_citation_modal"
          />
        </>
      )}
      <Button onClick={handleBluesky}>
        <BlueskyIcon />
        <Label>Bluesky</Label>
      </Button>
      <Button onClick={handleTweet}>
        <FontAwesomeIcon className="fa fa-twitter" />
        <Label>Twitter</Label>
      </Button>
      <Button onClick={handleFacebook}>
        <FacebookIcon />
        <Label>Facebook</Label>
      </Button>
      <Button onClick={handleCopy}>
        <CopyIcon />
        <Label>Copy</Label>
      </Button>
      <Button onClick={handleShare}>
        <FontAwesomeIcon className="fa fa-share" />
        <Label>Share</Label>
      </Button>
      <Button onClick={handleSave}>
        <AddIcon />
        <Label>Save</Label>
      </Button>
    </Container>
  );
}
